// extracted by mini-css-extract-plugin
export default {"page-onboarding":"style_page-onboarding__4n-rS"};